import { useStore } from '@data/store'
import { UnsyncedDataSlice } from '@data/store/slices/unsyncedData'

/**
 * @deprecated Use `clearSnackbars()` or `enqueueSnackbar()` instead
 */
export function clearFlashMessages(): void {
    useStore.getState().unsyncedData.setFlashMessages(null)
}

export const enqueueSnackbar = useStore.getState().unsyncedData.enqueueSnackbar
export const clearSnackbars = useStore.getState().unsyncedData.clearSnackbars

export function setIsImpersonated(newValue: boolean): void {
    useStore.setState((state) => ({
        ...state,
        unsyncedData: {
            ...state.unsyncedData,
            data: {
                ...state.unsyncedData.data,
                isImpersonated: newValue,
            },
        },
    }))
}

export const setStartNavigationCounterValue = (
    newValue: number
): ReturnType<UnsyncedDataSlice['startNavCounter']['setValue']> =>
    useStore.getState().unsyncedData.startNavCounter.setValue('value', newValue)

export const setHasTriggeredTheTimer: UnsyncedDataSlice['startNavCounter']['setHasTriggeredTheTimer'] =
    useStore.getState().unsyncedData.startNavCounter.setHasTriggeredTheTimer

export const setEnabledFlag = (): void => {
    useStore.getState().unsyncedData.startNavCounter.setValue('value', 1)
    useStore.getState().unsyncedData.startNavCounter.setValue('enabled', true)
}

export function setIsGoogleTagInitialized(newValue: boolean): void {
    useStore.setState((state) => ({
        ...state,
        unsyncedData: {
            ...state.unsyncedData,
            isGoogleTagInitialized: newValue,
        },
    }))
}

/**
 * See `frontend/realms/global/hooks/useWatchForUpgradeSuccessFlashMessage.ts`
 * @TODO We can remove this whole feature once we move to SSR.
 */
export function clearShowUpgradeSuccessMessage(): void {
    useStore.setState((state) => ({
        ...state,
        unsyncedData: {
            ...state.unsyncedData,
            showUpgradeSuccessMessage: false,
        },
    }))
}
